import React from 'react';

export interface SpinnerProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export function Spinner({ size = 'md', className = '', ...props }: SpinnerProps) {
  const sizes = {
    sm: 'aspectly:text-xl',
    md: 'aspectly:text-2xl',
    lg: 'aspectly:text-4xl',
    xl: 'aspectly:text-6xl',
  };

  return (
    <span
      className={`material-symbols-outlined aspectly:text-primary aspectly:animate-spin ${sizes[size]} ${className}`}
      {...props}
    >
      progress_activity
    </span>
  );
}
